export const typeObject = {
    Accountnumber: "String",
    Amount: "Currency",
    AmountDue: "Currency",
    BankAccountValidatedBy: "String",
    BankAccountValidatedOn: "String",
    BankCurrencyCode: "Currency",
    BankName: "String",
    BankValidationId: "String",
    BankValidationStatus: "String",
    BillingAddress: "Address",
    BillingAddressRecipient: "String",
    CompanyCustomerId: "String",
    CompanyCustomerName: "String",
    CompanyCustomerType: "String",
    CompanySupplierId: "String",
    CompanySupplierName: "String",
    ContainsDeliveryNote: "Bool",
    CoyId: "String",
    CoyName: "String",
    CurrencyId: "Currency",
    CustomerAddress: "String",
    CustomerAddressRecipient: "String",
    CustomerId: "String",
    CustomerName: "String",
    CustomerType: "String",
    Description: "String",
    TotalDiscount: "Currency",
    DepartmentId: "String",
    DueDate: "Date",
    FNTaxCodeId: "String",
    FNNetValue: "Currency",
    Freight: "Currency",
    IBAN: "String",
    IFSC: "String",
    InvoiceBankValidationStatus: "String",
    InvoiceDate: "Date",
    InvoiceDescription: "String",
    InvoiceHeaderDescription: "String",
    InvoiceDocumentClassificationId: "String",
    InvoiceDueDateMethod: "String",
    InvoiceId: "String",
    InvoiceTotal: "Currency",
    IsCrewRecovery: "Bool",
    IsMasterAndOwners: "Bool",
    IsMultiCompany: "Bool",
    IsProformaInvoice: "Bool",
    MessageId: "Guid",
    Packaging: "Currency",
    PaymentTerm: "String",
    PaymentTermDays: "String",
    PurchaseOrder: "String",
    PurchaseOrderNumber: "String",
    PurchaseOrderValidated: "Bool",
    Quantity: "Double",
    RecoveryPCN: "String",
    RecoverySeafarerName: "String",
    RecoveryServiceType: "String",
    RecoveryType: "String",
    RecoveryAmount: "Currency",
    RecoveryOneTime: "Bool",
    RecoveryFI: "String",
    RecoveryVesselId: "String",
    RecoveryVesselName: "String",
    ServiceEndDate: "Date",
    ServiceStartDate: "Date",
    ShippingAddress: "String",
    ShippingAddressRecipient: "String",
    ShipsureBankValidationStatus: "String",
    SourceId: "String",
    SubTotal: "Currency",
    SupplierId: "String",
    SupplierName: "String",
    SWIFT: "String",
    Tax: "String",
    TaxRate: "String",
    TaxType: "String",
    TotalTax: "Currency",
    Unit: "String",
    UnitPrice: "Currency",
    VendorAddress: "Address",
    VendorAddressRecipient: "String",
    VendorName: "String",
    VesselId: "String",
    VesselName: "String"
};
